import { FC } from 'react';

import SelectionItem from './SelectionItem';
import { ListWrapper } from './Wrapper';
import { SelectionItemProps, SelectionListProps } from './types';

export * from './types';
export { ListItemWrapper } from './Wrapper';
export { SelectionItem };

const SelectionList: FC<SelectionListProps> = ({
  list,
  itemSize,
  onChange,
  onLoadError,
  canUnselect = false,
  isBackground = false,
  renderIndexes = false,
  renderListItemComponent,
  selectedItemIndexes = [],
  ...itemProps
}) => (
  <ListWrapper isFullWidth={itemSize === 'full_width'} size={itemSize}>
    {list.map((item, i) => {
      const isSelected = !!selectedItemIndexes?.includes(i);
      const isLastChild = i + 1 === list.length;

      const index = i + 1 === 10 ? 0 : i + 1;
      const canRenderIndex = renderIndexes && index < 10 && !isLastChild;

      const handleChange = () => {
        isSelected && canUnselect ? onChange(null) : onChange(item);
      };

      const listItemProps: SelectionItemProps = {
        ...item,
        ...itemProps,
        isSelected,
        isBackground,
        onLoadError,
        onChange: handleChange,
        ...(canRenderIndex && { index })
      };

      const key = `${item.name || i}/${item.id}/${item.iconSrc}`;

      if (renderListItemComponent) {
        if (item.renderContent) return <li>{item.renderContent()}</li>;

        if (item.id) return <li key={key}>{renderListItemComponent(listItemProps)}</li>;

        return null;
      }

      return <SelectionItem key={key} {...listItemProps} />;
    })}
  </ListWrapper>
);

export default SelectionList;
